import { initLiveList } from '../../shared/liveList.js';

// The AI cost log (M10).
//
// Nothing but the live list: the page is read-only - a recorded request has no
// decision left to make - so there is no action to wire beyond filtering and
// paging without a reload.

export function initKiKosten() {
  initLiveList({
    results: 'ki-kosten-list',
    path: '/ki/kosten',
    forms: ['ki-kosten-filter']
  });
}
